import { useModalStore } from '#pplx/frontend/aether/modals/store/useModalStore.js';
import { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
const selector = (store) => store.removeModal;
export function useManagedModalLifecycle(modalState) {
    const removeModal = useModalStore(selector);
    const exitAnimationsRef = useRef(new Set());
    const hasCommittedOpenRef = useRef(false);
    const registerExitAnimation = useCallback((isExitPending) => {
        exitAnimationsRef.current.add(isExitPending);
        return () => {
            exitAnimationsRef.current.delete(isExitPending);
        };
    }, []);
    const onExitComplete = useCallback(() => {
        if (modalState.status !== 'exiting') {
            return;
        }
        removeModal({ id: modalState.id });
    }, [modalState.id, modalState.status, removeModal]);
    const onErrorRecovery = useCallback(() => {
        removeModal({ id: modalState.id });
    }, [modalState.id, removeModal]);
    useLayoutEffect(() => {
        if (modalState.status === 'open') {
            hasCommittedOpenRef.current = true;
            return;
        }
        const hasPendingExitAnimation = Array.from(exitAnimationsRef.current).some((isExitPending) => isExitPending());
        if (!hasCommittedOpenRef.current || !hasPendingExitAnimation) {
            onExitComplete();
        }
    }, [modalState.status, onExitComplete]);
    return useMemo(() => ({
        status: modalState.status,
        onExitComplete,
        onErrorRecovery,
        registerExitAnimation,
    }), [modalState.status, onExitComplete, onErrorRecovery, registerExitAnimation]);
}
//# sourceMappingURL=useManagedModalLifecycle.js.map